<div class="blocos-inline mb-3">
  <div class="bloco-item">
    <h3 class="uppercase">Observações e Comentários</h3>
    <hr>
    <div class="comentarios-container ps-show-always">
      <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center" style="height: 170px;">
        <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
      </div>
      <div *ngIf="!isLoading &&  (pedido?.comentarios && pedido?.comentarios?.length <= 0)"
        class="bloco-unico mt-3 d-flex justify-content-center align-items-center" style="height: 170px;">
        <span>Nenhum comentário até o momento!</span>
      </div>
      <div *ngFor="let comentario of pedido?.comentarios">
        <div class="bloco-unico mb-3" [ngClass]="comentario.isCliente ? 'comentario-cliente' : 'comentario-admin'">
          <h4><strong>{{comentario.usuario}}</strong> - {{comentario.dataInclusao | date: 'dd/MM/yyyy HH:mm'}}</h4>
          <p>{{comentario.mensagem}}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="bloco-item">
    <h3 class="uppercase">Registrar</h3>
    <hr>
    <form [formGroup]="formComentario" class="comentario-input">
      <mat-form-field>
        <textarea matInput required minlength="20" maxlength="2000" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
          rows="5" wrap="hard" formControlName="comentario" matTooltip="Mínimo de 20 caracteres"
          placeholder="Adicionar comentário"></textarea>
      </mat-form-field>
      <small class="hint">
        <span [ngStyle]="comentario?.length >= 1500 && {'color': 'orange'}"
          [ngStyle]="comentario?.length === 2000 && {'color': 'red', 'font-weight': '700'}">
          {{ 2000 - comentario?.length }}
        </span> / 2000
      </small>
    </form>
    <div class="d-flex justify-content-end">
      <button mat-flat-button color="primary" [disabled]="formComentario.invalid"
        (click)="incluirPedidoObsComentario()">Salvar</button>
    </div>
  </div>
</div>